import { useEffect, useState } from 'react';
import { useGameStore } from '../core/store/gameStore';

export function OrientationHint() {
    const isMobile = useGameStore((state) => state.isMobile);
    const isGameStarted = useGameStore((state) => state.isGameStarted);
    const [isLandscape, setIsLandscape] = useState(true);

    useEffect(() => {
        const check = () => setIsLandscape(window.innerWidth > window.innerHeight);
        check();
        window.addEventListener('resize', check);
        window.addEventListener('orientationchange', check);
        return () => {
            window.removeEventListener('resize', check);
            window.removeEventListener('orientationchange', check);
        };
    }, []);

    if (!isMobile || !isGameStarted || isLandscape) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '12px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 60,
            padding: '8px 16px',
            borderRadius: '20px',
            background: 'rgba(0,0,0,0.55)',
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#fff',
            fontSize: '11px',
            letterSpacing: '1px',
            pointerEvents: 'none',
            backdropFilter: 'blur(4px)',
            whiteSpace: 'nowrap',
            fontFamily: 'Cousine, monospace',
            opacity: 0.9,
        }}>
            ROTATE DEVICE FOR BEST EXPERIENCE
        </div>
    );
}
